import { findConceptByName } from '../../data/Concepts';
import type { Concept } from '../../data/Concepts';

const INTRO_CONCEPT_NAME = 'coworking';

export const getIntroConcept = (): Concept => {
	const concept = findConceptByName(INTRO_CONCEPT_NAME);
	if (!concept) {
		throw new Error('Default concept is missing');
	}
	return concept;
};
